/**
 * Convert MSAL account to AuthUser
 */
export function convertMsalAccountToUser(account) {
  return {
    name: account.name || account.username,
    email: account.username,
    id: account.localAccountId,
  }
}

/**
 * Exchange MSAL access token for your backend token (if needed)
 */
export async function exchangeTokenWithBackend(accessToken) {
  // TODO: Implement backend token exchange if required

  // Example:
  // const response = await fetch('http://127.0.0.1:8000/auth/exchange-token', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify({ azureToken: accessToken }),
  // })
  // const data = await response.json()
  // return data.token

  // For now, use Azure AD token directly
  return accessToken
}
